import { Select } from 'components/common';
import { SelectProps } from 'components/common/select/Select';
import { useOptions } from 'hooks';
import { useOptionsDefault } from 'hooks/options/useOptionsDefault';
import { useEffect, useState } from 'react';
import { FindAllOptionsDto } from 'types';
import { filterOptions } from 'utils';

type SelectOptionsProps = SelectProps & Pick<FindAllOptionsDto, 'optionTypeId' | 'service'>;

const SelectOptions = ({ optionTypeId, service, ...props }: SelectOptionsProps) => {
  const { data, isLoading } = useOptions({
    optionTypeId,
    service
  });

  const [keyword, setKeyword] = useState('');

  const handleSearch = (val: string) => {
    setKeyword(val);
  };

  const { optionsDefault, isLoading: isLoadingDefault } = useOptionsDefault({
    optionTypeId,
    service
  });

  useEffect(() => {
    if (optionsDefault) {
      props.onChange?.(optionsDefault.optionId, {
        label: optionsDefault.name,
        value: optionsDefault.optionId
      });
    }
  }, [optionsDefault]);

  const options = filterOptions(data, keyword, 'name');

  return (
    <Select
      showSearch
      {...props}
      filterOption={false}
      onSearch={handleSearch}
      loading={isLoading || isLoadingDefault}
      options={options.map((itm) => ({
        label: itm.name,
        value: itm.optionId
      }))}
    />
  );
};
export default SelectOptions;
